<template>
  <div class="partner-modal">
    <div class="error-modal-body">
      <div class="row" style="width: 100%; margin: 0; padding: 0">
        <div class="title" style="width: 100%">
          <p>Картын лимит нэмэх</p>
          <button @click.esc="close">x</button>
        </div>
      </div>
      <b-alert
        v-if="showMessage"
        variant="warning"
        dismissible
        :show="true"
        class="warning"
        style="margin-left: auto; margin-right: auto; margin-top: 25px"
      >
        {{ errorMessage }}
      </b-alert>
      <form
        action="POST"
        class="user-edit-panel-profile"
        @submit.prevent="sendData"
      >
        <div class="form-group">
          <label for="">Хязгаар / Limit :<span>*</span> </label>
          <div class="user-input">
            <input
              type="number"
              class="form-control"
              v-model="limit"
              required
            />
          </div>
        </div>
        <div class="form-group" style="justify-content: center">
          <input type="submit" class="btn user-btn" value="Хадгалах" />
        </div>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      limit: 0,
      showMessage: false,
      errorMessage: "",
    };
  },
  props: ["childrenCard"],
  methods: {
    close() {
      this.$emit("close");
    },
    sendData() {
      var userOwnData = this.$auth.getMe();
      if (!userOwnData) {
        // Optionally redirect or handle the missing user
        return;
      }

      var cardHolderInfId = userOwnData.cardHolderInfId;

      this.$cardApi
        .post(
          "/kid-card/add/dailyLimit",
          {
            walletId: cardHolderInfId,
            addAmount: this.limit,
            systemId: "BONUS",
          },
          {
            headers: {
              "Accept-Language": "mn",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            this.$emit("close");
            this.$toast.success("Амжилттай!");
          } else {
            this.errorMessage = response.data.message;
            this.showMessage = true;
          }
        })
        .catch((error) => {
          this.errorMessage = error.response.data.message || "Алдаа гарлаа";
          this.showMessage = true;
        });
    },
  },
};
</script>
<style scoped>
.partner-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  z-index: 10;
  padding: 0;
  margin: 0;
}
.error-modal-body {
  position: absolute;
  top: 15%;
  width: 500px;
  box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.15);
  border-radius: 14px;
  background-color: #fff;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0;
  margin: 0;
  padding-bottom: 30px;
}
.title {
  float: left;
}
.title p {
  padding: 8px 0;
  margin: 0;
  color: #fff;
  background-color: #1660ab;
  border-top-right-radius: 14px;
  border-top-left-radius: 14px;
  padding-left: 22px;
}
.title button {
  top: 6px;
  right: 24px;
  position: absolute;
  background: none;
  border: none;
  color: #fff;
}
.error-modal-body .error-error {
  margin-top: 37px !important;
  font-size: 13px;
  width: 306px;
  padding-left: 18px;
  line-height: 1.38;
  flex: 5;
  height: 49px;
  color: rgba(0, 0, 0, 0.8);
  margin: 0;
  text-align: left;
}
.error-modal-body div p {
  margin: 0;
}
</style>
